// src/components/tour/worker/DisplayQRTourSteps.tsx
import { Step } from 'react-joyride';

const DisplayQRTourSteps: Step[] = [
  {
    // ✅ Corregido: era '.font-semibold.text-gray-900' (demasiado genérico, colisiona con otros elementos)
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a la sección de <strong>Generación de QR</strong>. Aquí
        puedes ver y gestionar los códigos QR que tus clientes pueden escanear
        para acceder a tu página web o directamente a tu agenda de reservas.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    // ✅ Corregido: era '.hidden.sm\\:flex...' (frágil y dependiente de clases de estilo)
    target: '.tour-help-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Si necesitas volver a ver esta guía en cualquier momento, pulsa el botón
        de <strong>Ayuda</strong> en la parte superior derecha.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    // ✅ Nueva: explica la tarjeta completa de página web
    target: '.tour-card-catalogo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Esta tarjeta contiene el <strong>QR de tu página web</strong>. Los
        clientes pueden escanearlo para ver el catálogo de servicios de tu
        empresa y conocer toda la información antes de reservar.
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },
  {
    // ✅ Nueva: imagen del QR de catálogo
    target: '.tour-qr-image-catalogo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este es el <strong>código QR de la página web</strong>. Puedes
        imprimirlo y colocarlo en tu local, tarjetas de visita o cualquier
        material promocional para que los clientes accedan fácilmente.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    // ✅ Corregido: era '.tour-link-text' que no existía en el componente
    target: '.tour-link-catalogo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí se muestra el <strong>enlace público de tu página web</strong>.
        Puedes compartirlo directamente con tus clientes para que accedan desde
        cualquier dispositivo sin necesidad de escanear el QR.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    // ✅ Corregido: era '.tour-download-button' que no existía en el componente
    target: '.tour-download-catalogo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Con este botón puedes <strong>descargar el QR de la página web</strong>{' '}
        en formato imagen. Úsalo para imprimirlo o insertarlo en carteles y
        materiales de marketing.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    // ✅ Corregido: era '.tour-copy-button' que no existía en el componente
    target: '.tour-copy-catalogo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este botón <strong>copia el enlace de la página web</strong> al
        portapapeles para que puedas compartirlo fácilmente por WhatsApp, correo
        o redes sociales.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    // ✅ Nueva: tarjeta completa de reservas
    target: '.tour-card-reservas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Esta tarjeta contiene el <strong>QR de reservas</strong>. Al escanearlo,
        el cliente accede directamente al formulario de reserva de citas
        contigo, sin pasar por la página general de la empresa.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    // ✅ Nueva: imagen del QR de reservas
    target: '.tour-qr-image-reservas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este es el <strong>código QR de tu agenda de citas</strong>. Es
        especialmente útil si quieres que los clientes reserven contigo
        directamente, sin tener que seleccionar un trabajador.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-link-reservas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí se muestra el <strong>enlace directo a tu agenda</strong>. Puedes
        compartirlo en tu perfil de redes sociales, bio de Instagram o cualquier
        otro canal para facilitar las reservas.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-download-reservas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Descarga el <strong>QR de reservas</strong> para imprimirlo y colocarlo
        en tu puesto de trabajo, espejo o mostrador. Así tus clientes podrán
        reservar su próxima cita al instante.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-copy-reservas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Copia el <strong>enlace de tu agenda</strong> al portapapeles para
        compartirlo por WhatsApp, correo o redes sociales con un solo clic.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
];

export default DisplayQRTourSteps;
